import type { AuthLogin, AuthPassword } from "~/types/schemas/autenticacao";
import type { Usuario, UsuarioAvatar } from "~/types/schemas/usuario";
import { API } from "~/composables/api";

class AutenticacaoAPI {
  get = async (token: string) => {
    return await API.getOne(`/auth`, { headers: { 'Authorization': token } });
  }
  
  login = async (payload: AuthLogin) => {
    return await API.post(`/auth`, { body: payload as AuthLogin });
  }

  //? A API devolve um token novo: a troca de senha derruba os tokens antigos.
  senha = async (payload: AuthPassword) => {
    return await API.put<AuthPassword & { token?: string }>(`/auth/senha`, { body: payload });
  }

  //? "Meu Perfil": a API só aceita nome e avatar do próprio usuário. O X-User da resposta já
  //? atualiza o usuário na store (~/composables/api).
  perfil = async (payload: { nome: string; avatar_id: number }) => {
    return await API.put<Usuario>(`/auth/perfil`, { body: payload });
  }

  avatares = async () => {
    return await API.get<UsuarioAvatar>(`/auth/avatares`);
  }

  forgetPassword = async (payload: Partial<AuthLogin>) => {
    return await API.post(`/auth/esqueci-senha`, { body: payload });
  }
}

export const AutenticacaoApi = new AutenticacaoAPI();